module.exports = "pegasus/assets/theme6/twitter.png";